import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled.div`
	padding: 15px 24px;
	white-space: nowrap;
`;

const Copyright = ({ isCollapsed, isMobile, originYear, thisYear }) => {
	const yearDelta = thisYear - originYear;

	return isMobile ? (
		<Wrapper>
			&copy; {originYear} {yearDelta > 0 && `- ${thisYear}`} Sorted Group
			Ltd
		</Wrapper>
	) : (
		<Wrapper>
			{isCollapsed ? (
				<>
					&copy;
					<br />
					{thisYear}
				</>
			) : (
				<>
					&copy; {originYear} {yearDelta > 0 && `- ${thisYear}`}
					<br />
					Sorted Group Ltd
				</>
			)}
		</Wrapper>
	);
};

Copyright.propTypes = {
	isCollapsed: PropTypes.bool,
	isMobile: PropTypes.bool,
	originYear: PropTypes.number.isRequired,
	thisYear: PropTypes.number
};

Copyright.defaultProps = {
	isMobile: false,
	isCollapsed: false,
	thisYear: new Date().getFullYear()
};

export default Copyright;
